// Order Statuses
export const orderStatuses = [
  { label: 'Bekliyor', value: 1 },
  { label: 'Kabul Edildi', value: 2 },
  { label: 'Hazırlanıyor', value: 3 },
  { label: 'Tamamlandı', value: 4 },
  { label: 'İptal Edildi', value: 5 }
];

export const pharmacyDutyOptions = [
  { label: 'Nöbetçi', value: true },
  { label: 'Nöbetçi Değil', value: false }
];

export const isTurpPharmacy = [
  { label: 'Evet', value: true },
  { label: 'Hayır', value: false }
];

export const activeStatuses = [
  { label: 'Aktif', value: 1 },
  { label: 'Pasif', value: 2 }
];
